import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import DashboardLayout from "@/components/DashboardLayout";
import { useAuth } from "@/context/AuthContext";
import { SessionCard } from "@/pages/mentor/MentorSessions";
import { EmptyState, ErrorState } from "@/components/StateViews";
import { Video, Loader2 } from "lucide-react";

export default function StudentSessions() {
  const { user } = useAuth();
  const isAssociation = user?.role === "association";
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await api.get("/sessions");
      setSessions(data.sessions || []);
    } catch (e) {
      setError(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  return (
    <DashboardLayout>
      <div data-testid="student-sessions">
        <div className="mb-8">
          <div className="text-xs font-bold uppercase tracking-widest text-teal-700">{isAssociation ? "جلسات المتابعة الثلاثية" : "جلساتي الإرشادية"}</div>
          <h1 className="mt-2 text-2xl font-heading font-black text-slate-900">{isAssociation ? "جلسات الطلاب مع الموجّه" : "جلسات مع الموجّه"}</h1>
          <p className="mt-2 text-slate-600">{isAssociation ? "تابع الجلسات الثلاثية المدعو إليها ممثل الجمعية عبر Microsoft Teams." : "تابع جلساتك القادمة عبر Microsoft Teams وراجع الملاحظات السابقة."}</p>
        </div>

        {loading ? (
          <div className="grid place-items-center py-16"><Loader2 className="h-8 w-8 animate-spin text-teal-700" /></div>
        ) : error ? (
          <ErrorState message={error} onRetry={load} testid="student-sessions-error" />
        ) : sessions.length === 0 ? (
          <EmptyState
            icon={Video}
            title="لا توجد جلسات بعد"
            description="سيقوم موجّهك بجدولة جلسات قريباً."
            testid="student-sessions-empty"
          />
        ) : (
          <div className="space-y-3">
            {sessions.map((s) => (
              <div key={s.id}>
                <SessionCard s={s} />
                {!isAssociation && s.notes && (
                  <div className="mt-2 me-16 p-4 rounded-xl bg-cream-50 border border-cream-200">
                    <div className="text-xs font-bold text-teal-700 mb-1">ملاحظات الموجّه</div>
                    <div className="text-sm text-slate-700 whitespace-pre-line">{s.notes}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
